
import DatePicker from "nlib/ui/DatePicker";
import Platforms from "utils/Platforms";
import React, { useMemo } from "react";
import moment from "moment";

const DatePickerLocalized = (props) => {
  const translations = useMemo(() => {
    return {
      months: moment.months(),
      days: moment.weekdaysShort()
    };
  }, []);

  return (
    <DatePicker modal={Platforms.checkIsTouchDevice()} translations={translations} {...props} />
  );
};

export default React.memo(DatePickerLocalized);
